module.exports = __webpack_public_path__ + "static/media/dashboard.c7997107.svg";